import Session from './../controllers/LoginController';


export function borrarDatosSessionStorage(){
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('username')
    sessionStorage.removeItem('idRol')
    sessionStorage.removeItem('usuarioFiltro')
    sessionStorage.removeItem('nombreUsuario')
    sessionStorage.removeItem('id_user')
    sessionStorage.removeItem('areaUser')
    sessionStorage.removeItem('user_')
    sessionStorage.removeItem('email')
    sessionStorage.removeItem('banMonitoreo')
    sessionStorage.removeItem('usuarioLogueado')
    sessionStorage.removeItem('banConfig')
    sessionStorage.removeItem('rol')
    sessionStorage.removeItem('ubicacionTiempoReal')
    sessionStorage.removeItem('key');
    sessionStorage.removeItem("inactividad_mostrar_modal");
    localStorage.removeItem('aciqui_instance');
    localStorage.setItem("pointNotificacion", "false");
}

export async function verificarAcceso() {
    const token = sessionStorage.getItem('token');
    const key = sessionStorage.getItem('key');
	try{
        await Session.verificaAcceso(token, key);
        
    }catch(error){
        console.error(error);
    }
}